import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-header__sortable-content"
}
const _hoisted_2 = { class: "table-header__text" }
const _hoisted_3 = {
  key: 1,
  class: "order-alert-header"
}
const _hoisted_4 = { class: "order-alert-header__title" }
const _hoisted_5 = { class: "order-status-content" }
const _hoisted_6 = { class: "order-status-content__header order-status-header" }
const _hoisted_7 = { class: "order-status-header__title" }
const _hoisted_8 = { class: "order-status-header__description" }
const _hoisted_9 = { class: "order-status-content__order-status order-status" }
const _hoisted_10 = { class: "order-status__container--description" }
const _hoisted_11 = {
  key: 3,
  class: "table-header__text"
}

import { i18n } from '@/i18n';
import TableHead from '../TableHead.vue';
import { TableContentProperty } from '../../interface/tableContentHeaders';
import { BaseTableContentViewModel } from '../../baseTableContentViewModel';
import ArrowIcon from '../../components/ArrowIcon.vue';
import OrderStatusBadge from '@/corePagesModule/components/OrderStatusBadge.vue';
import HelpIconWithModal from '@/corePagesModule/components/HelpIconWithModal.vue';
import { orderStatusDescriptions } from '@/corePagesModule/BaseTableContent/components/order/orderStatus';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderTableHead',
  props: {
    header: {},
    headerIndex: {},
    accumulationTableContentWidth: {},
    isVariableWidth: { type: Boolean },
    isAllSelected: { type: Boolean },
    stableColumnCount: {},
    isOrderGroupEditMode: { type: Boolean },
    editingId: {}
  },
  emits: ["onClickSort", "onMousedownResizer"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const baseTableContentVM = new BaseTableContentViewModel();

// emits
const emits = __emit;

//変数
const t = i18n.t;

const isPaddingAvailCond = computed(() => {
  switch (props.header.key) {
    case 'OrderEditButton':
      return props.isOrderGroupEditMode;
    case 'OrderDeleteButton':
      return !props.editingId;
    default:
      return false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableHead, {
    class: _normalizeClass([_unref(baseTableContentVM).isSticky(_ctx.stableColumnCount, _ctx.headerIndex) ? 'sticky-content' : '', isPaddingAvailCond.value ? 'no-padding' : '']),
    style: _normalizeStyle({
      left: _unref(baseTableContentVM).calcStickyDiff(_ctx.stableColumnCount, _ctx.headerIndex, _ctx.accumulationTableContentWidth),
    }),
    index: _ctx.headerIndex,
    resizable: 
      // 幅可変な列 && 固定する列に含まれていない -> 可変幅
      _ctx.header.isVariableWidth && !_unref(baseTableContentVM).isSticky(_ctx.stableColumnCount, _ctx.headerIndex)
    ,
    "data-key": _ctx.header.key,
    onOnMousedownResizer: _cache[1] || (_cache[1] = ($event) => emits('onMousedownResizer', $event, _ctx.headerIndex))
  }, {
    default: _withCtx(() => [
      (_ctx.header.sortOption.isSortable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)(_ctx.header.key)), 1),
            _createVNode(ArrowIcon, {
              asc: _ctx.header.sortOption.isAsc,
              onOnClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onClickSort', _ctx.headerIndex, _ctx.header, _ctx.header.sortOption.isAsc)))
            }, null, 8, ["asc"])
          ]))
        : (_ctx.header.key === 'OrderRecommendStatus')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)(_ctx.header.key)), 1),
              _createVNode(HelpIconWithModal, { "use-transform": true }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('ステータスとは')), 1),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('LEANPATHでは発注に関するステータスが10種類あります。')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orderStatusDescriptions), (status, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "order-status__container"
                        }, [
                          _createVNode(OrderStatusBadge, {
                            class: "order-status__container--badge",
                            "order-status-str": status.status
                          }, null, 8, ["order-status-str"]),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)(status.description)), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ], undefined, true),
                _: 1
              })
            ]))
          : (_ctx.header.key === 'OrderEditButton')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(t)(_ctx.header.key)), 1))
    ], undefined, true),
    _: 1
  }, 8, ["class", "style", "index", "resizable", "data-key"]))
}
}

})